import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/utils/bluestoneAuth'

Vue.use(VueRouter)

/** 蓝石集团审核专用页（需登录） */
const BLUESTONE_HOME_PATH = '/bluestone'
/** 蓝石集团审核专用页 · 登录页 */
const BLUESTONE_LOGIN_PATH = '/bluestone/login'

const routes = [
  {
    path: '/recommender/purchase/:inviteCode',
    name: 'RecommenderPurchase',
    component: () => import('@/views/recommenderPurchase/index.vue')
  },
  {
    path: '/recommender/purchase',
    name: 'RecommenderPurchaseNoCode',
    component: () => import('@/views/recommenderPurchase/index.vue')
  },
  {
    path: BLUESTONE_HOME_PATH,
    name: 'BluestoneRecommender',
    component: () => import('@/views/bluestone/index.vue')
  },
  {
    path: BLUESTONE_LOGIN_PATH,
    name: 'BluestoneLogin',
    component: () => import('@/views/bluestone/login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 审核页登录态守卫：本地没有 token 或 token 已过期，一律回登录页；已登录访问登录页则直接进审核页
router.beforeEach((to, from, next) => {
  if (to.path !== BLUESTONE_HOME_PATH && to.path !== BLUESTONE_LOGIN_PATH) {
    return next()
  }
  if (to.path === BLUESTONE_LOGIN_PATH) {
    return isLoggedIn() ? next(BLUESTONE_HOME_PATH) : next()
  }
  return isLoggedIn() ? next() : next(BLUESTONE_LOGIN_PATH)
})

export default router